import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpService  } from '../../core/services/http/http.service';
import { Categories  } from '../../../store/actions/categoriesActions';
@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  constructor(private store: Store<any>,private http: HttpService) { }
  categories(){
   
    return this.http.query('get', 'allCategories', {}, '');
  }
 
  dispatchCatAction()
  {
    this.store.dispatch(new Categories());
  }
}
